
export enum AffiliationEventType {
    AFFILIATION_CREATED = "affiliation.affiliationCreated",
    AFFILIATION_INVALIDATED = "affiliation.affiliationInvalidated",
    AFFILIATION_UPDATED = "affiliation.affiliationUpdated",
}
